import type { InvolvedAffiliate, Transfer } from '@/types/payout';
import { Box, List, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface FailedTransfersListProps {
  failedTransfers: Transfer[];
  involvedAffiliates: InvolvedAffiliate[];
}

/** Names the affiliates whose transfer did not go through, with the reason given. */
const FailedTransfersList: React.FC<FailedTransfersListProps> = ({
  failedTransfers,
  involvedAffiliates,
}) => {
  const { t } = useTranslation();

  const getAffiliateName = (affiliateId: string): string => {
    const affiliate = involvedAffiliates.find((ia) => ia.id === affiliateId);
    return affiliate?.name || t('payouts.failure.unknownAffiliate');
  };

  return (
    <Box>
      <List.Root gap={1}>
        {failedTransfers.map((transfer) => (
          <List.Item key={transfer.id} fontSize="sm">
            <Text as="span" fontWeight="medium">
              {getAffiliateName(transfer.affiliateId)}
            </Text>
            {transfer.failureReason && (
              <Text as="span" color="fg.muted">
                : {transfer.failureReason}
              </Text>
            )}
          </List.Item>
        ))}
      </List.Root>
    </Box>
  );
};

export default FailedTransfersList;
